<div class="accord-holder" [hidden]="getAccordVisibility">
    <div  class="accord">
        <div class="accord-title" [ngClass]="{ 'active': filtersAccord.active }" >
            <button class="ct-btn arrow-btn" (click)="onAccordTitleClick(filtersAccord)">
                <span class="fa" [ngClass]="getAccordIcon(filtersAccord)"></span>
            </button>
            {{filtersAccord.name}}
        </div>
        <app-report-filter *ngIf="filtersAccord.active"></app-report-filter>
    </div>
</div>


<!-- main -->
<div class="container-fluid">
    <div class="row">
        <div class="col">
            <div class="container-tab">
                
                <div class="panel">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>